import TRTR from "./TRTR.json";
import ENUS from "./ENUS.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  "en-US": {
    translation: ENUS,
  },
  "tr-TR": {
    translation: TRTR,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("LANG") ? localStorage.getItem("LANG") : "tr-TR",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
    prefix: "$",
    suffix: "$",
  },
});

export default i18n;
